// src/components/Footer.js
import React from 'react';

export default function Footer() {
  return (
    <footer className="section">
      <div className="container footer-columns">
        <div className="footer-column">
          <a href="/" aria-current="page" className="nuxt-link-exact-active nuxt-link-active">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c"
              alt="ft"
              className="footer-logo"
              width="69"
              height="25"
            />
          </a>
        </div>

        <div className="footer-column">
          <span className="section-title">FlourishTalents</span>
          <a href="javascript:void(0)" className="footerspacing">About</a>
          <a href="javascript:void(0)" className="footerspacing">Tenders</a>
          <a href="javascript:void(0)" className="footerspacing">Careers</a>
          <a href="javascript:void(0)" className="footerspacing">Sponsorships</a>
          <a href="javascript:void(0)" className="footerspacing">Partnership</a>
        </div>

        <div className="footer-column">
          <span className="section-title">Legal</span>
          <a href="javascript:void(0)" className="footerspacing">Terms of Use</a>
          <a href="javascript:void(0)" className="footerspacing">Privacy Policy</a>
          <a href="javascript:void(0)" className="footerspacing">Cookie Policy</a>
          <a href="javascript:void(0)" className="footerspacing">Terms of Service</a>
        </div>

        <div className="footer-column">
          <span className="section-title">Support</span>
          <a href="javascript:void(0)" className="footerspacing">Help Center</a>
          <a href="javascript:void(0)" className="footerspacing">Contact</a>
          <a href="javascript:void(0)" className="footerspacing">FAQs</a>
        </div>

        <div className="footer-column">
          <span className="section-title">Get the App</span>
          <a href="javascript:void(0)" className="footerspacing" target="_blank" rel="noreferrer">iOS</a>
          <a href="javascript:void(0)" className="footerspacing" target="_blank" rel="noreferrer">Android</a>
        </div>
      </div>

      <div className="footer-icons">
        {/* Instagram */}
        <a
          href="https://www.instagram.com/@flourishtalents"
          target="_blank"
          rel="noreferrer"
          title="Instagram"
        >
          <span className="icon is-normal" style={{ fontSize: 24 }}>
            <svg viewBox="0 0 24 24">
              <path d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z" />
            </svg>
          </span>
        </a>

        {/* TikTok */}
        <a
          href="https://www.tiktok.com/@flourishtalents"
          target="_blank"
          rel="noreferrer"
          title="TikTok"
        >
          <span className="icon is-normal" style={{ fontSize: 24 }}>
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M13.6091 4.5683C12.7517 4.5683 11.9607 4.28426 11.3254 3.80511C10.5968 3.25582 10.0734 2.45009 9.88853 1.52141C9.84275 1.29195 9.81811 1.05516 9.81576 0.8125H7.36657V7.50486L7.36364 11.1706C7.36364 12.1506 6.72544 12.9816 5.84078 13.2738C5.58403 13.3586 5.30675 13.3988 5.01802 13.383C4.64949 13.3627 4.30413 13.2515 4.00396 13.0719C3.36518 12.6899 2.93209 11.9968 2.92035 11.204C2.90187 9.9649 3.90361 8.95465 5.14185 8.95465C5.38627 8.95465 5.62101 8.99456 5.84078 9.06703V7.23784V6.58029C5.60897 6.54596 5.37306 6.52806 5.13451 6.52806C3.7792 6.52806 2.51162 7.09143 1.60553 8.10637C0.920686 8.87338 0.509896 9.85194 0.446517 10.878C0.363478 12.226 0.85672 13.5074 1.81327 14.4528C1.95382 14.5916 2.10141 14.7204 2.25575 14.8392C3.07587 15.4704 4.07849 15.8125 5.13451 15.8125C5.37306 15.8125 5.60897 15.7949 5.84078 15.7606C6.82726 15.6144 7.73745 15.1629 8.45575 14.4528C9.33836 13.5804 9.82603 12.4223 9.83131 11.1896L9.81869 5.71557C10.2398 6.04039 10.7001 6.30917 11.1943 6.51779C11.9627 6.84202 12.7776 7.00633 13.6162 7.00604V5.22761V4.56771C13.6167 4.5683 13.6097 4.5683 13.6091 4.5683Z"/>
            </svg>
          </span>
        </a>

        {/* YouTube */}
        <a
          href="https://www.youtube.com/@flourishtalents"
          target="_blank"
          rel="noreferrer"
          title="YouTube"
        >
          <span className="icon is-normal" style={{ fontSize: 24 }}>
            <svg viewBox="0 0 24 24">
              <path d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z" />
            </svg>
          </span>
        </a>

        {/* LinkedIn */}
        <a
          href="https://www.linkedin.com/company/@flourishtalents"
          target="_blank"
          rel="noreferrer"
          title="LinkedIn"
        >
          <span className="icon is-normal" style={{ fontSize: 24 }}>
            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.067 5.9V18.16H.985V5.9h4.082zm.26-3.785c.008.602-.2 1.105-.625 1.51-.425.403-.983.605-1.676.605h-.025c-.676 0-1.22-.202-1.633-.606C.956 3.22.75 2.717.75 2.115.75 1.505.962 1 1.387.6c.425-.4.98-.6 1.664-.6.684 0 1.233.2 1.645.6.412.4.623.905.63 1.515zm14.423 9.018v7.026h-4.07v-6.556c0-.866-.167-1.544-.5-2.035-.335-.49-.856-.736-1.565-.736-.52 0-.955.142-1.305.427a2.63 2.63 0 00-.786 1.057c-.09.248-.136.582-.136 1.002v6.84h-4.07c.017-3.29.025-5.957.025-8.002 0-2.046-.004-3.266-.012-3.662L7.318 5.9h4.07v1.782h-.025c.165-.264.334-.495.507-.693a5.28 5.28 0 01.7-.643c.292-.231.65-.41 1.075-.538a4.903 4.903 0 011.417-.192c1.41 0 2.544.468 3.402 1.404.857.936 1.286 2.307 1.286 4.113z" />
            </svg>
          </span>
        </a>

        {/* Facebook */}
        <a
          href="https://www.facebook.com/@flourishtalents"
          target="_blank"
          rel="noreferrer"
          title="Facebook"
        >
          <span className="icon is-normal" style={{ fontSize: 24 }}>
            <svg width="14" height="22" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.634.78v3.29h-2.348c-.858 0-1.436.15-1.735.449-.3.299-.449.748-.449 1.346V8.22h4.382l-.583 3.69H9.102v9.46H4.525v-9.46H.711V8.22h3.814V5.503c0-1.545.519-2.744 1.556-3.596C7.118 1.056 8.499.63 10.224.63c1.466 0 2.602.05 3.41.15z" />
            </svg>
          </span>
        </a>
      </div>
    </footer>
  );
}
